import type VueI18n from 'vue-i18n';
import { computed } from 'vue';
import { useVm } from './useVm';

export function useI18n() {
  const vm = useVm();
  const i18n = vm.$i18n as VueI18n;

  return {
    i18n,
    t: vm.$t.bind(vm) as typeof vm.$t,
    tc: vm.$tc.bind(vm) as typeof vm.$tc,
    te: vm.$te.bind(vm) as typeof vm.$te,
    locale: computed({
      get: () => i18n.locale,
      set: (value: string) => {
        i18n.locale = value;
      },
    }),
  };
}
